import {z as zod} from "zod";

export type OttokartLeadsWorkspaceCapabilityConfiguration = Record<string, never>;

/**
 * Coerce null/unknown DB payloads to {} so workspace bootstrap does not fail client validation.
 */
export const ottokartLeadsWorkspaceCapabilityConfigurationValidator: zod.ZodType<OttokartLeadsWorkspaceCapabilityConfiguration> =
    zod.unknown().transform(() => ({}));
